import React from 'react';

import capitalize from 'lodash.capitalize';

import CheckBox from '@pb/kit-component-checkbox';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {EditSection} from './edit-section';
import {RemoveSection} from './remove-section';

import {section, sectionDragHandle} from './sections-row.module.styl';

import type {Section} from 'src/openapi/admin/models/Section';

type Props = {
    section: Section,
    readonly?: boolean,
    onUpdate: () => void,
};

export const EditSectionsRowView = (props: Props) => {
    const {section: {
        id,
        conferenceId,
        sectionName,
        sectionType,
        webVersionEnabled,
        mobileVersionEnabled,
    }, readonly, onUpdate} = props;

    return (
        <Group className={`${section} section`}>
            <Item style={{width: 225}} className="pl-m">
                <Group alignItems="center">
                    {!readonly && (
                        <Icon type={Icons.SORT_ICON} className={`${sectionDragHandle} section__drag-handle`}/>
                    )}
                    <Item style={{width: 190}}>
                        <EllipsisTextHint title={sectionName}>
                            {sectionName}
                        </EllipsisTextHint>
                    </Item>
                </Group>
            </Item>
            <Item style={{width: 125}}>
                {capitalize(sectionType)}
            </Item>
            <Item style={{width: 215}}>
                {!readonly && (
                    <Group>
                        <EditSection
                            sectionId={id}
                            conferenceId={conferenceId}
                            onSave={onUpdate}
                        />
                        <RemoveSection
                            sectionId={id}
                            sectionName={sectionName}
                            onRemove={onUpdate}
                        />
                    </Group>
                )}
            </Item>
            <Item style={{width: 77}}>
                <CheckBox
                    checked={webVersionEnabled}
                    disabled={true}
                />
            </Item>
            <Item style={{width: 93}}>
                <CheckBox
                    checked={mobileVersionEnabled}
                    disabled={true}
                />
            </Item>
        </Group>
    );
};
